export const InterceptorConstants = {
  FORM_URL_ENCODED: 'application/x-www-form-urlencoded;charset=UTF-8',
  JSON_CONTENT_TYPE: 'application/json',
  LOGIN_CONTENT_TYPE: 'application/x-www-form-urlencoded',
  CLIENT_ID_KEY: 'client_id',
  CLIENT_SECRET_KEY: 'client_secret',
  GRANT_TYPE_KEY: 'grant_type',
  COMMERCIAL_GRANT_TYPE: 'mhk_password'
};
